import { render, staticRenderFns } from "./client-products.vue?vue&type=template&id=404854ae"
import script from "./client-products.vue?vue&type=script&lang=js"
export * from "./client-products.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports